export const isVolumeOverAreas = (statVal) => !!statVal &&
    typeof statVal === 'object' &&
    statVal.siteGallons !== undefined;
//# sourceMappingURL=siteProfile.js.map